import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 18H2.5V5C2.5 4.45 2.05 4 1.5 4C0.95 4 0.5 4.45 0.5 5V18C0.5 19.1 1.4 20 2.5 20H12.5C13.05 20 13.5 19.55 13.5 19C13.5 18.45 13.05 18 12.5 18ZM17.5 14V2C17.5 0.9 16.6 0 15.5 0H6.5C5.4 0 4.5 0.9 4.5 2V14C4.5 15.1 5.4 16 6.5 16H15.5C16.6 16 17.5 15.1 17.5 14ZM15.5 14H6.5V2H15.5V14Z",
		fill: "#525252"
	})
});
export default SvgCopyIcon;
